/* eslint-disable */
import flatpickr from "flatpickr";
import $ from "jquery";
import mask from "jquery-mask-plugin";
import "../vendor/datepicker/en-NZ.js";
import "../vendor/datepicker/datepicker.js";

const DocumentLibrary = () => {
    const dateFrom = $("#df");
    const dateTo = $("#dt");

    dateTo.focusin(() => {
        dateTo.attr("placeholder", "dd/mm/yyyy");
        dateTo.mask("00/00/0000");
    });

    dateFrom.focusin(() => {
        dateFrom.attr("placeholder", "dd/mm/yyyy");
        dateFrom.mask("00/00/0000");
    });

    dateFrom.focusout(() => {
        dateFrom.attr("placeholder", "From");
    });

    dateTo.focusout(() => {
        dateTo.attr("placeholder", "To");
    });

    const dropdownFilters = document.querySelectorAll(".dropdown-filter");
    const dropdownList = [].slice.call(dropdownFilters);

    const dropdownTab = () => {
        const dropdown = $(".dropdown-filter--active");
        const focusableEls = dropdown.find(".dropdown-list").find(".category-checkbox");
        const lastFocusableEls = focusableEls.last()[0];
        const heading = $(".dropdown-filter--active > .dropdown-heading");

        $(lastFocusableEls).focusout(function () {
            dropdown.focus();
            if (dropdown.attr("aria-label") === "Document Type") {
                window.scrollBy(0, -50);
            }
        });

    heading.keyup(function (e) {
      if ($(e.target).is(":focus") && (e.which == 13 || e.which == 32)) {
        if ($(e.target).parent().hasClass('dropdown-filter--active')) {
          $(e.target).parent().removeClass('dropdown-filter--active');
        } else {
          $('.dropdown-filter').removeClass('dropdown-filter--active');
          $(e.target).parent().addClass('dropdown-filter--active');
        }
      }
    });
  };

    const createSelects = () => {
        $(document).on("click", function (e) {
            if ( $(e.target).hasClass("dropdown-heading")) {
                if ($(e.target).parent().hasClass('dropdown-filter--active')) {
                    $(e.target).parent().removeClass('dropdown-filter--active');
                } else {
                    $('.dropdown-filter').removeClass('dropdown-filter--active');
                    $(e.target).parent().addClass('dropdown-filter--active');
                    $(e.target).focus();
                    dropdownTab();
                }

                return;
            }

        if ($(window).outerWidth() > 767) {
          if ($('.dropdown-filter--active').length && !$(e.target).closest('.dropdown-filter--active').length) {
            $('.dropdown-filter').removeClass('dropdown-filter--active');
            return;
          }
        }
    });

    $(document).keypress(function(e) {
      if ($(e.target).is('input, textarea, select, [contenteditable]')) {
        return;
      }
      if (e.which == 13 || e.which == 32) {
        dropdownList.forEach((el) => {
          dropdownTab();
          const dropdown = $(el);
          if (dropdown.is(":focus")) {
            e.preventDefault();
            dropdown.toggleClass("dropdown-filter--active");
          }
        });
      }
    });

        document.addEventListener('keydown', e => {
            const keyCode = e.keyCode;

            if (keyCode === 27) {
                dropdownList.forEach((el) => {
                    dropdownTab();
                    const dropdown = $(el);

                    if (dropdown.hasClass("dropdown-filter--active")) {
                        e.preventDefault();
                        dropdown.removeClass("dropdown-filter--active");
                    }
                });
            }
        });

        $(".document-filters--mobile .field--date-published").on("click", function () {
            $(this).toggleClass("active");
        });
    };

    const setupDatePickers = () => {
        const datepickers = [].slice.call(document.querySelectorAll(".datepicker"));

        if (datepickers) {
            datepickers.forEach(el => {
                $(el).datepicker({
                    theme: 'bootstrap',
                    inputFormat: ["dd/MM/yyyy"],
                    outputFormat: 'dd/MM/yyyy'
                });
            });
        }
    };

    const init = () => {
        setupDatePickers();
        createSelects();
    };

    if ($(".no-document-results")[0]) {
        $(".no-results-title").html("no");
    }

  // Handle mobile filter dropdown clicks
  $(document).on("click", ".filter-heading", function() {
    $(this).toggleClass("filter-heading--active");
    $(".category-filter-holder").toggleClass("category-filter-holder--active");
  });

  // Handle mobile filter dropdown key presses
  $(document).on("keyup", ".filter-heading", function(e) {
    if (e.keyCode === 13 || (e.keyCode === 32 && $(this).is(":focus"))) {
      $(this).toggleClass("filter-heading--active");
      $(".category-filter-holder").toggleClass("category-filter-holder--active");
    }
  });

  // Handle mobile filter category dropdown clicks
  $(document).on("click", ".category-heading", function (e) {
    e.preventDefault();
    $(this).closest('.category-filter-item').toggleClass("category-filter-item--active");
  });

  // Handle mobile filter category heading dropdown key presses
  $(document).on("keyup", ".category-heading", function (e) {
    if (e.keyCode === 13 || (e.keyCode === 32 && $(this).is(":focus"))) {
      e.preventDefault();

      $(this).closest('.category-filter-item').toggleClass("category-filter-item--active");
    }
  });

  // Handle mobile filter category item dropdown key presses
  $(document).on("keyup", ".category-filter-item", function (e) {
    if (!$(this).is(e.target)) {
      return;
    }

    const isEnterOrSpace = e.keyCode === 13 || e.keyCode === 32;

    if (isEnterOrSpace) {
      e.preventDefault();
      $(this).toggleClass("category-filter-item--active");
    }
  });

  // Keypress (Enter/Spacebar) toggle for all mobile filter accordions
  $(document).on("keydown", ".dropdown-filter", function (e) {
    const isEnterOrSpace = e.keyCode === 13 || e.keyCode === 32;

    if (isEnterOrSpace && $(this).is(":focus")) {
      const $accordionContainer = $(this);
      const accordionTitle = $accordionContainer.find('.dropdown-heading').text().trim();

      $accordionContainer.toggleClass("dropdown-filter--active");
      $accordionContainer.removeClass("disabled");

      // Dynamic border override
      if ($accordionContainer.hasClass("dropdown-filter--active")) {
        $accordionContainer.css("border", "0");
      } else {
        // Clean up the inline border style when closing
        $accordionContainer.css("border", "");
      }

      // Prevent the Spacebar from scrolling the page
      e.preventDefault();
    }
  });

  // Handler for the main "Filter and sort" block
  $(document).on("keydown", ".col-12 > .dropdown", function (e) {
    const isEnterOrSpace = e.keyCode === 13 || e.keyCode === 32;

    if (isEnterOrSpace && $(this).is(":focus")) {
      const $parentAccordion = $(this).closest('.dropdown-filter');

      $(this).parent().toggleClass("dropdown-filter--active");
      $(this).parent().css("border", "0");

      e.preventDefault();
    }
  });

  // Keypress (Enter or Space) toggle for Date Published field
  $(document).on("keydown", ".field--date-published", function (e) {
    if ((e.keyCode === 13 || e.keyCode === 32) && $(this).is(":focus")) {
      $(this).toggleClass("field-group field--date-published active");
    }
  });

  // Handle mobile filter dropdown clicks
  $(document).on("click", ".filter-heading", function () {
    $(this).toggleClass("filter-heading--active");
    $(".category-filter-holder").toggleClass("category-filter-holder--active");
  });

  // Keypress (Enter or Space) toggle for filter dropdown
  $(document).on("keyup", ".filter-heading", function (e) {
    if ((e.keyCode === 13 || (e.keyCode === 32) && $(this).is(":focus"))) {
      $(this).toggleClass("filter-heading--active");
      $(".category-filter-holder").toggleClass("category-filter-holder--active");
    }
  });

    // Handler for the main "Filter and sort" block
    $(document).on("keydown", ".col-12 > .dropdown", function (e) {
        const isEnterOrSpace = e.keyCode === 13 || e.keyCode === 32;

        if (isEnterOrSpace && $(this).is(":focus")) {
            const $parentAccordion = $(this).closest('.dropdown-filter');

            $(this).parent().toggleClass("dropdown-filter--active");
            $(this).parent().css("border", "0");

            e.preventDefault();
        }
    });

    // Keypress (Enter or Space) toggle for Date Published field
    $(document).on("keydown", ".field--date-published", function (e) {
        if ((e.keyCode === 13 || e.keyCode === 32) && $(this).is(":focus")) {
            $(this).toggleClass("field-group field--date-published active");
        }
    });

    // Handle mobile filter dropdown clicks
    $(document).on("click", ".filter-heading", function () {
        $(this).toggleClass("filter-heading--active");
        $(".category-filter-holder").toggleClass("category-filter-holder--active");
    });

    // Keypress (Enter or Space) toggle for filter dropdown
    $(document).on("keyup", ".filter-heading", function (e) {
        if ((e.keyCode === 13 || (e.keyCode === 32) && $(this).is(":focus"))) {
            $(this).toggleClass("filter-heading--active");
            $(".category-filter-holder").toggleClass("category-filter-holder--active");
        }
    });

    // Select radio button on Spacebar press
    $(document).on("keydown", ".radio-container .radio", function (e) {
        if (e.keyCode === 32) {
            e.preventDefault();
            e.target.checked = true;
        }
    });

    if (document.body.classList.contains("MBIE\\PageTypes\\DocumentLibraryPage")) {
        init();
    }
};

export default DocumentLibrary;

/* eslint-enable */
